import { render, staticRenderFns } from "./hub_details_list.vue?vue&type=template&id=5e6fac79"
import script from "./hub_details_list.vue?vue&type=script&lang=js"
export * from "./hub_details_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports